import {Injectable} from '@angular/core';
import { Headers } from '@angular/http';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import {Token} from './token';

@Injectable()
export class AuthenticationService {
    
    private subject = new BehaviorSubject(null);
    
    constructor() {
        if (this.isTokenValid()) {
            this.subject.next(this.getToken().userName);
        }
    }

    getHeader() : Headers {
        var headers = new Headers();
        headers.append('X-Authorization', this.getToken().value);
        return headers;
    }

    getHeaderPDF() : Headers {
        var headers = new Headers();
        headers.append('X-Authorization', this.getToken().value);
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/pdf');
        return headers;
    }
    
    getHeaderByToken(token: any) : Headers {
        var headers = new Headers();
        headers.append('X-Authorization', token.value);
        return headers;
    }

    getUserName(): Observable<any> {
        return this.subject.asObservable();
    }
    
    setToken(token: Token) {
        localStorage.setItem('currentToken', JSON.stringify(token));
        this.subject.next(token.userName);
    }

    setStorageName(storageName: string) {
        localStorage.setItem('storageName', storageName);
    }

    getStorageName() : string {
        return localStorage.getItem('storageName');
    }
    
    isTokenValid() : boolean {
        let token : Token;
        token = this.getToken();
        if (token!=null) {
            let dateString = token.validUntil.toString().split(/[-T.]/);
            let checkDate = new Date( dateString.slice(0,3).join('/')+' '+dateString[3] );
            if (token.value!=null && token.validUntil!=null) {
                if (checkDate.valueOf() >= Date.now().valueOf() ) {
                    return true;
                }
            }
        }
        return false;
    }
    
    getToken() : Token {
        return JSON.parse(localStorage.getItem('currentToken'));
    }
    
    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentToken');
        this.subject.next(null);
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/services/security/authentication.service.ts